import React from 'react';
import { extractIcon, formatClassName } from './chart-base';
import PieChart from './pie-chart';
/* eslint import/no-webpack-loader-syntax: off */
import male_svg from '!!raw-loader!images/male.svg';
import female_svg from '!!raw-loader!images/female.svg';

const icons = {
  'M': male_svg,
  'F': female_svg,
  '1': male_svg,
  '2': female_svg
};

function customFormatClassNameFn(str) {
  if (str.toLowerCase().indexOf('female') >= 0) str = 'female';
  else if (str.toLowerCase().indexOf('male') >= 0) str = 'male';
  return formatClassName(str);
}

function sortValues(values) {
  return values;
}

function labelWriterFn(labelGroup, isUpdate, slice, i, d3Refs) {
  if (isUpdate) return;

  const legendRectH = 50;
  const legendRectW = 25;
  const legendSpacing = 4;

  const offset = legendRectW + legendSpacing;
  const vert = -((legendRectH / 2) + (legendSpacing / 2));
  const horz = (legendSpacing / 2) - (i * offset);

  const icon = extractIcon(icons[slice.data[0]]);
  if (icon) {
    icon.setAttribute('style', 'width:' + legendRectW + 'px;height:' + legendRectH + 'px');
    icon.setAttribute('width', legendRectW);
    icon.setAttribute('height', legendRectH);
  }

  // Append icon divider bar only once (runs once per slice on enter)
  const centerGroup = d3Refs.svg.select('.center');
  if (centerGroup.select('.gender-center-divider').empty()) {
    centerGroup
      .append('rect')
      .attr('class', 'gender-center-divider')
      .attr('width', 1)
      .attr('height', legendRectH)
      .attr('x', -0.5)
      .attr('y', -(legendRectH / 2))
      .style('fill', '#ddd');
  }

  // Move the label off-center left or right as appropriate
  labelGroup.attr('transform', `translate(${horz},${vert})`);

  // Append a semi-opaque rectangle to provide a hit-area for clicking
  labelGroup.append('rect')
    .attr('width', legendRectW)
    .attr('height', legendRectH)
    .style('fill', '#fff')
    .style('opacity', '0.01');

  // Append the icon
  if (icon) {
    labelGroup.node().appendChild(icon);
  }
}

const GenderChart = (props) => (
  <PieChart
    {...props}
    donutWidth={8}
    chartVariantClassName="gender-chart"
    sortValues={sortValues}
    customFormatClassNameFn={customFormatClassNameFn}
    labelWriterFn={labelWriterFn}
  />
);

export default GenderChart;
